<template>
<v-form @keyup.native.enter="trySingUp" ref="form">
    <h3 class="display-1 py-8 font-weight-bold">{{ $t('registration') }}</h3>
    <v-alert dense text type="info" v-html="$t('browserInfo')">
    </v-alert>
    <v-text-field
      name="fullname"
      type="text"
      v-model="fullName"
      :label="$t('nameSurname')"
      outlined
    ></v-text-field>
    <v-text-field name="company" type="text" v-model="school"
    :label="$t('school')" outlined></v-text-field>
    <v-text-field
      name="email"
      type="text"
      v-model="email"
      :error="error.email"
      :error-messages="error.email ? this.$t('emailRegistred') : null"
      :rules="emailRules"
      :label="$t('email')"
      outlined
    ></v-text-field>
    <v-text-field
      type="password"
      v-model="password"
      :label="$t('password')"
      :error="error.password"
      :error-messages="errorPasswordText"
      @input="checkPassword"
      outlined
    ></v-text-field>
    <v-checkbox v-model="checkbox" :rules="[v => !!v || this.$t('conditions')]" required>
      <template v-slot:label>
        <div>
          {{ $t('conditionsButtonAgree') }}
          <a
            target="_blank"
            :href="$t('conditionsLink')"
            @click.stop
            v-on="on"
          >{{ $t('conditionsButtonCond') }}</a>
        </div>
      </template>
    </v-checkbox>
    <v-btn
      color="primary"
      depressed
      :disabled="!allValid"
      rounded
      large
      block
      @click="signUp"
    >{{ $t('registrationAction') }}</v-btn>
    <p class="caption py-6" align="center">
      {{ $t('moveBack') }}
      <router-link :to="{name: 'Login', params: {defaultEmail: this.email}}">
        {{ $t('login') }}</router-link>
    </p>
  </v-form>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SignUpForm',
  components: {
  },
  data() {
    return {
      email: this.$route.params.defaultEmail,
      emailRules: [
        v => (v ? this.validEmail() : this.inValidEmail(this.$t('emailRequired'))),
        v => (/.+@.+\..+/.test(v) ? this.validEmail() : this.inValidEmail(this.$t('emailValid'))),
      ],
      mailOK: false,
      password: '',
      school: '',
      fullName: '',
      error: {
        email: false,
        password: false,
        general: false,
      },
      checkbox: false,
    };
  },
  computed: {
    ...mapGetters(['auth']),
    allValid() {
      return (
        this.mailOK
        && (this.password.length >= 6)
        && this.school.length
        && this.fullName.length
        && this.checkbox
      );
    },
    errorPasswordText() {
      return this.error.password
        ? this.$t('passwordValidation')
        : null;
    },
  },
  methods: {
    trySingUp() {
      // eslint-disable-next-line no-unused-expressions
      this.allValid && this.signUp();
    },

    async signUp() {
      // eslint-disable-next-line no-return-assign
      Object.keys(this.error).forEach(v => this.error[v] = false);
      await this.$store
        .dispatch('signUp', {
          email: this.normalize(this.email),
          password: this.password,
          school: this.school,
          name: this.fullName,
        })
        .then(() => {
          this.$store.dispatch('logEvent', {
            name: 'user_signed_up',
          });
          this.$router.push('/home');
        })
        .catch((error) => {
          this.errorHandler(error);
          // this.error = true;
        });
    },
    checkPassword() {
      this.error.password = this.password.length < 7;
    },

    validEmail() {
      this.mailOK = true;
      return true;
    },

    inValidEmail(string) {
      this.mailOK = false;
      return string;
    },
    normalize(str) {
      return str.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    },

    errorHandler(error) {
      if (error.code === 'auth/email-already-in-use') {
        this.error.email = true;
      } else if (error.code === 'auth/weak-password') {
        this.error.password = true;
      } else {
        this.error.general = true;
      }
    },
  },
};
</script>

<style scoped>
.v-input--selection-controls {
  padding-bottom: 20px;
}
</style>
